/** Shared niche keys, labels, and color tokens for the platform. */

export const NICHE_KEYS = [
  "wellness",
  "beauty",
  "food",
  "fitness",
  "auto",
  "mind",
  "arts",
  "independent",
];

export const NICHE_META = {
  wellness: {
    label: "Wellness",
    browseLabel: "Wellness",
    badgeClass: "niche-badge--wellness",
    tileClass: "niche-tile--wellness",
  },
  beauty: {
    label: "Beauty",
    browseLabel: "Beauty",
    badgeClass: "niche-badge--beauty",
    tileClass: "niche-tile--beauty",
  },
  food: {
    label: "Food",
    browseLabel: "Food",
    badgeClass: "niche-badge--food",
    tileClass: "niche-tile--food",
  },
  fitness: {
    label: "Fitness",
    browseLabel: "Fitness",
    badgeClass: "niche-badge--fitness",
    tileClass: "niche-tile--fitness",
  },
  auto: {
    label: "Auto & Trades",
    browseLabel: "Auto",
    badgeClass: "niche-badge--auto",
    tileClass: "niche-tile--auto",
  },
  mind: {
    label: "Mind & Growth",
    browseLabel: "Mind",
    badgeClass: "niche-badge--mind",
    tileClass: "niche-tile--mind",
  },
  arts: {
    label: "Arts",
    browseLabel: "Arts",
    badgeClass: "niche-badge--arts",
    tileClass: "niche-tile--arts",
  },
  independent: {
    label: "Independent",
    browseLabel: "Independent",
    badgeClass: "niche-badge--independent",
    tileClass: "niche-tile--independent",
  },
};

/** Niches shown in browse / explore grids (subset of all keys). */
export const NICHE_BROWSE_LIST = [
  { key: "wellness", label: "Wellness" },
  { key: "beauty", label: "Beauty" },
  { key: "food", label: "Food" },
  { key: "fitness", label: "Fitness" },
  { key: "auto", label: "Auto" },
  { key: "mind", label: "Mind" },
];

/** Dropdown options for signup / waitlist forms. */
export const NICHE_OPTIONS = NICHE_KEYS.map((key) => ({
  key,
  label: NICHE_META[key].label,
}));

const LABEL_ALIASES = {
  auto: ["auto", "auto & trades", "auto and trades"],
  mind: ["mind", "mind & growth", "mind and growth"],
  food: ["food", "food & cooking", "food and cooking"],
  fitness: ["fitness", "fitness & sport", "fitness and sport"],
};

/**
 * Resolve a Firestore niche field, label string, or key to a canonical niche key.
 * @param {string | string[] | undefined | null} input
 * @returns {string}
 */
export function normalizeNicheKey(input) {
  if (Array.isArray(input)) {
    return normalizeNicheKey(input[0]);
  }
  if (!input || typeof input !== "string") {
    return "independent";
  }

  const trimmed = input.trim();
  const lower = trimmed.toLowerCase();

  if (NICHE_META[lower]) {
    return lower;
  }

  for (const [key, meta] of Object.entries(NICHE_META)) {
    if (
      meta.label.toLowerCase() === lower ||
      meta.browseLabel?.toLowerCase() === lower
    ) {
      return key;
    }
  }

  for (const [key, aliases] of Object.entries(LABEL_ALIASES)) {
    if (aliases.some((alias) => lower.includes(alias) || alias.includes(lower))) {
      return key;
    }
  }

  return "independent";
}

/**
 * @param {string | string[] | undefined | null} niche
 * @returns {{ key: string, label: string, browseLabel: string, badgeClass: string, tileClass: string }}
 */
export function getNicheMeta(niche) {
  const key = normalizeNicheKey(niche);
  return { key, ...NICHE_META[key] };
}
